<ui-card *ngIf="jobPosting">
    <app-segment-header title="applicant-tracker.jobOverview"></app-segment-header>
    <div class="app-grid">
        <div class="columns-6">
            <div>
                {{
                    {
                        key: 'applicant-tracker.dateOpenedWithDate',
                        params: { date: jobPosting.createdAt | appDate: 'longDate' },
                    } | appTranslate
                }}
            </div>
            <div>
                {{ jobPosting.title }},
                <span class="capitalize">{{ jobPosting.level | appTranslateOptions: employmentTypeDisplay }}</span>
            </div>
            <div>{{ jobPosting.city }}, {{ jobPosting.region }}, {{ jobPosting.country }}</div>
        </div>
        <div class="columns-6 app-grid">
            <div class="columns-1">
                <mat-icon class="overview-icon" svgIcon="group"></mat-icon>
            </div>
            <div class="columns-5">
                <div class="overview-stats">{{ jobPosting.totalApplicants }}</div>
                <div>{{ 'applicant-tracker.totalNumOfApplicants' | appTranslate }}</div>
            </div>

            <div class="columns-1">
                <mat-icon class="overview-icon" svgIcon="calendarDetail"></mat-icon>
            </div>
            <div class="columns-5">
                <div class="overview-stats">
                    {{ { key: 'applicant-tracker.daysWithAge', params: { age: jobPostingAge } } | appTranslate }}
                </div>
                <div>{{ 'applicant-tracker.jobPostingAge' | appTranslate }}</div>
            </div>
        </div>
    </div>
</ui-card>
